const TOKEN_KEY = 'local-jump-token'

export function setToken(value: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, JSON.stringify({ type: 'string', data: value }))
  } catch (e) {
    console.error('setToken:', e)
  }
}

export function getToken(): string {
  try {
    const raw = localStorage.getItem(TOKEN_KEY) || JSON.stringify({ type: 'string', data: '' })
    const parsed = JSON.parse(raw) as { data?: string }
    return parsed.data || ''
  } catch (e) {
    console.error('getToken:', e)
    return ''
  }
}

export function removeToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch (e) {
    console.error('removeToken:', e)
  }
}
